// import axios from 'axios'
// import router from '@/router/index'
// import qs from 'qs'
// import { setToken,setRefreshToken,getCookie} from "@/utils/common";
// import { Toast } from 'vant';

// // 创建axios实例
// const service = axios.create({
//    baseURL: process.env.VUE_APP_BASE_URL // url = base url + request url 正式环境 .env.production
// })
//   // 请求
//   service.interceptors.request.use(
//     config => {
//       config.paramsSerializer = function(params) {
//         return qs.stringify(params, {arrayFormat: 'repeat'})
//       };
//       // 带token访问的接口
//       const arr=['/business/addBusiness','/busEduConfig/getBusEduConfig',
//     '/deptItemConfig/listItemByDeptId','/mobile/listPayData','/pay/getQrcodeUrl','/pay/cashPay','/cloudPrint/getPrintMessage','/cloudPrint/dascomPrint',
//     '/user/getAuth','/userAuth/dept/getDeptListByUserName','/user/getAuthSwitch','/sso/logout','/busEduConfig/getItemConfig',
//     '/busFieldConfig/listBusFieldConfiged','/report/getRoadName','report/sideParkingPayCollect','/report/sideParkingPayDetail','/report/sideParkingPayCollect',
//     // 融资担保 
//     '/guarantee/calculateGuaranteeOrder','/guarantee/saveGuaranteeOrder','/guarantee/listOrderByParams','/guarantee/editGuaranteeOrder','/guarantee/qrcodeUrlGuaranteeOrder',
//     '/sysFunConfig/getSysFunConfig','/epay/place_order',
//     // 通用上门
//     '/mobile/pageOwnPayed'
//     ]
//       let bool = false
//       arr.forEach((val) => {
//         if (config.url==val) {
//           bool = true
//         }
//       })
//       if (bool == true && getCookie('token')) {
//         // 请求头传递token值
//         config.headers['Authorization'] = getCookie('token')
//       } else if (bool == true && !getCookie('token')) {
//         router.push({path: '/login?vde='+localStorage.getItem('vde')+'&fromtype='+localStorage.getItem('loginFromType') })
//         Toast('登陆过期了，请重新登陆');
//         return config
//       }
      
//       return config
//     },
//     error => {
//       return Promise.reject(error)
//     }
//   )
  
  
//   let isRefreshing = false;   //token刷新状态
//   let subscribers = [];
//   let isRefreshingError = false; // 刷新token之后
//   let oldToken= getCookie('token')
//   let showConfirm = false
//   // 响应
//   service.interceptors.response.use(
//     response => {
//       const res = response.data
//       if(res.code == 2013) {
//         Toast('登陆过期了，请重新登陆');
//         setToken('')
//         router.push({path: '/login?vde='+localStorage.getItem('vde')+'&fromtype='+localStorage.getItem('loginFromType') })
//       }
//       return response
//     },
//     error => {
//         if (error && error.response && error.response.status === 401 && error.response.data.code == 2005) {
//           const { config } = error.response;
//           isRefreshingError = true;
//           oldToken = getCookie('token')
//           if(!isRefreshing){
//             isRefreshing = true;
//             return getNewToken().then((res)=>{
//               if (res.data.code==1000) {
//                   setTimeout(()=>{
//                     isRefreshingError = false;
//                   },30000)
//                   setToken(res.data.result.token)
//                   setRefreshToken(res.data.result.refreshToken)
//                   config.headers['Authorization'] = getCookie('token')
//                   subscribers.forEach(cb => cb(getCookie('token')))
//                   subscribers = [];
//                   return service(config)
//               }else{
//                 Toast(res.data.message);
//                 subscribers = [];
//                 setToken('')
//                 router.push({path: '/login?vde='+localStorage.getItem('vde')+'&fromtype='+localStorage.getItem('loginFromType') })
//                 return reject(error)
//               }
//             }).catch(res => {
//               }).finally(()=> {
//                 isRefreshing = false;
//               })
//           }else {
//             return new Promise((resolve) => {
//               subscribers.push(() => {
//                 config.baseURL = '';
//                 config.headers['Authorization'] = getCookie('token');
//                 resolve(service(config))
//               })
//             })
//           }
//         }else if(error.response.status === 401 && error.response.data.code == 2010 ) {
//           const { config } = error.response;
//           if (isRefreshingError) {
//             config.baseURL = process.env.VUE_APP_BASE_URL;
//             return service(config)
//           }else  {
//             if (config.headers.Authorization == getCookie('token')) {
//               if (!showConfirm) {
//                 showConfirm = true;
//                 if (showConfirm) {
//                   Toast(error.response.data.message);
//                   router.push({path: '/login?vde='+localStorage.getItem('vde')+'&fromtype='+localStorage.getItem('loginFromType') })
//                   showConfirm = false;
//                 }
//               } else {
//                 return new Promise((resolve) => {
//                   resolve()
//                 })
//               }
//             }else if(oldToken != getCookie('token')){
//               config.headers['Authorization'] = getCookie('token');
//               config.baseURL = '';
//               resolve(service(config))
//             }
           
//           }
//         }
//         else if(error.response.status === 401 && (error.response.data.code == 2010 || error.response.data.code == 2011 || error.response.data.code == 2012 || error.response.data.code == 2014||error.response.data.code == 4000 || error.response.data.code == 4001 ||error.response.data.code == 4002)) {
//           Toast(error.response.data.message);
//           router.push({path: '/login?vde='+localStorage.getItem('vde')+'&fromtype='+localStorage.getItem('loginFromType') })
//         }
//         else{
//           return Promise.reject(error)
//         }
//     }
//   )
  
  
//   function getNewToken(){
//     return axios.post(process.env.VUE_APP_BASE_URL+'/sso/refreshToken?refreshToken='+getCookie('refreshToken'),
//       {},
//       {
//         headers:{'Authorization':getCookie('token')}
//       }
//       )
//   }
  
  
//   export default service


import axios from 'axios'
import router from '@/router/index'
import qs from 'qs'
import { setToken,getCookie} from "@/utils/common";
import { Toast } from 'vant';

// 创建axios实例
const service = axios.create({
   baseURL: process.env.VUE_APP_BASE_URL // url = base url + request url 正式环境 .env.production
})
  // 请求
  service.interceptors.request.use(
    config => {
      config.paramsSerializer = function(params) {
        return qs.stringify(params, {arrayFormat: 'repeat'})
      };
      // 带token访问的接口
      const arr=['/business/addBusiness','/busEduConfig/getBusEduConfig',
      '/deptItemConfig/listItemByDeptId','/mobile/listPayData','/pay/getQrcodeUrl','/pay/cashPay','/cloudPrint/getPrintMessage','/cloudPrint/dascomPrint',
      '/user/getAuth','/userAuth/dept/getDeptListByUserName','/user/getAuthSwitch','/sso/logout','/busEduConfig/getItemConfig',
      '/busFieldConfig/listBusFieldConfiged','/report/getRoadName','report/sideParkingPayCollect','/report/sideParkingPayDetail','/report/sideParkingPayCollect',
      // 融资担保 
      '/guarantee/calculateGuaranteeOrder','/guarantee/saveGuaranteeOrder','/guarantee/listOrderByParams','/guarantee/editGuaranteeOrder','/guarantee/qrcodeUrlGuaranteeOrder',
      '/sysFunConfig/getSysFunConfig','/epay/place_order',
      // 通用上门
      '/mobile/pageOwnPayed'
      ]
      let bool = false
      arr.forEach((val) => {
        if (config.url==val) {
          bool = true
        }
      })
      if (bool == true && getCookie('token')) {
        // 请求头传递token值
        config.headers['Authorization'] = getCookie('token')
      } else if (bool == true && !getCookie('token')) {
        router.push({path: '/login?vde='+localStorage.getItem('vde')+'&fromtype='+localStorage.getItem('loginFromType') })
        Toast('登陆过期了，请重新登陆');
        return config
      }
      
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )
  
  
  let isRefreshing = false;   //token刷新状态

  // 响应
  service.interceptors.response.use(
    response => {

      return response
    },
    error => {
        if (error && error.response && error.response.status === 401) {

          let res = error.response.data;
          if (res.code == 230) {
            if (!isRefreshing) {
              isRefreshing = true;
                 Toast( res.message);
                  setToken('')
                  if (localStorage.getItem('vde')) {
                    router.push({path: '/login?vde='+localStorage.getItem('vde')+'&fromtype='+localStorage.getItem('loginFromType') })
                  } else {
                    router.push({ path: '/login' })
                  }
                  setTimeout(()=>{
                    isRefreshing = false;
                  },15000)
            }
          }else if (res.code == 301 || res.code == 302 || res.code == 322 ||res.code == 300) {
            Toast( res.message);
          }
        }
        else{
          return Promise.reject(error)
        }
    }
  )
  
  
  export default service
